(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["malim-header"]) return;
  try {
    
(function(){
  let scheduled=false;
  const update=()=>{
    scheduled=false;
    document.querySelectorAll('[data-home-transparent]').forEach(header=>{
      header.classList.toggle('m-header--solid',window.scrollY>20);
    });
  };
  const schedule=()=>{if(!scheduled){scheduled=true;requestAnimationFrame(update);}};
  window.addEventListener('scroll',schedule,{passive:true});
  window.addEventListener('pageshow',schedule);
  document.addEventListener('shopify:section:load',schedule);
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',schedule,{once:true});
  else schedule();
})();

(function(){
  if(window.malimNavigationReady)return;
  window.malimNavigationReady=true;
  document.addEventListener('toggle',function(event){
    const group=event.target;
    if(!group.matches?.('[data-malim-nav-group]')||!group.open)return;
    group.parentElement.querySelectorAll(':scope > [data-malim-nav-group][open]').forEach(function(other){if(other!==group)other.open=false;});
  },true);
  document.addEventListener('keydown',function(event){
    if(event.key!=='Escape')return;
    const group=document.activeElement?.closest('.m-header__nav [data-malim-nav-group][open]');
    if(group){group.open=false;group.querySelector('summary').focus();}
  },true);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["malim-home-products"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('malim-home-products')){
  class MalimHomeProducts extends HTMLElement{
    connectedCallback(){
      if(this.ready)return;
      this.ready=true;
      this.track=this.querySelector('[data-home-products-track]');
      this.navigation=this.querySelector('[data-home-products-navigation]');
      this.previous=this.querySelector('[data-home-products-previous]');
      this.next=this.querySelector('[data-home-products-next]');
      this.more=this.querySelector('[data-home-products-next-page]');
      this.abort=new AbortController();
      const options={signal:this.abort.signal};
      this.previous.addEventListener('click',()=>this.move(-1),options);
      this.next.addEventListener('click',()=>this.move(1),options);
      this.track.addEventListener('scroll',()=>this.update(),{passive:true,signal:this.abort.signal});
      this.track.addEventListener('keydown',event=>{
        if(event.target!==this.track)return;
        if(event.key==='ArrowLeft'||event.key==='ArrowRight'){
          event.preventDefault();this.move(event.key==='ArrowLeft'?-1:1);
        }
      },options);
      this.more?.addEventListener('click',event=>{event.preventDefault();this.loadRemaining();},options);
      this.resize=new ResizeObserver(()=>this.update());this.resize.observe(this.track);
      this.update();
      if(this.more){
        this.visibility=new IntersectionObserver(entries=>{
          if(entries.some(entry=>entry.isIntersecting)){this.visibility.disconnect();this.loadRemaining();}
        },{rootMargin:'400px 0px'});
        this.visibility.observe(this);
      }
    }
    disconnectedCallback(){this.abort?.abort();this.resize?.disconnect();this.visibility?.disconnect();this.ready=false;}
    move(direction){
      this.track.scrollBy({left:direction*this.track.clientWidth,behavior:'auto'});
    }
    update(){
      const maximum=this.track.scrollWidth-this.track.clientWidth;
      this.navigation.hidden=maximum<2;
      this.previous.disabled=this.track.scrollLeft<2;
      this.next.disabled=this.track.scrollLeft>=maximum-2;
    }
    async loadRemaining(){
      if(this.loading||!this.more)return;
      this.loading=true;
      this.more.setAttribute('aria-busy','true');
      const seen=new Set();
      try{
        while(this.isConnected&&this.more?.href){
          const url=new URL(this.more.href,window.location.href);
          url.searchParams.set('section_id',this.dataset.sectionId);
          if(url.origin!==window.location.origin||seen.has(url.href))break;
          seen.add(url.href);
          const response=await fetch(url,{credentials:'same-origin',signal:this.abort.signal});
          if(!response.ok)throw new Error('Homepage products could not be loaded');
          const parsed=new DOMParser().parseFromString(await response.text(),'text/html');
          const incoming=[...parsed.querySelectorAll('malim-home-products')].find(rail=>rail.dataset.sectionId===this.dataset.sectionId);
          if(!incoming)throw new Error('Homepage product section is unavailable');
          const existing=new Set([...this.track.querySelectorAll('[data-home-product]')].map(card=>card.dataset.homeProduct));
          const cards=[...incoming.querySelectorAll('[data-home-products-track] > [data-home-product]')].filter(card=>!existing.has(card.dataset.homeProduct));
          this.track.append(...cards.map(card=>document.importNode(card,true)));
          const next=incoming.querySelector('[data-home-products-next-page]');
          if(next)this.more.href=next.href;
          else{this.more.remove();this.more=null;}
          this.update();
        }
      }catch(error){
        if(error.name!=='AbortError'&&this.more)this.more.removeAttribute('aria-busy');
      }finally{
        this.loading=false;
        this.more?.removeAttribute('aria-busy');
      }
    }
  }
  customElements.define('malim-home-products',MalimHomeProducts);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["malim-product-tracksuit-set"]) return;
  try {
    
/* Tracksuit-Set only: per-option stock by size label (XS/S orange, M red, L green). No inventory change.
   NOTE: {% javascript %} is compiled statically — no Liquid inside (section.id would stay literal). */
(function(){
  const mapTone=(size)=>{
    const s=String(size||'').trim().toUpperCase();
    if(s==='S')return 'orange';
    if(s==='M')return 'red';
    return 'green';
  };
  const findOptionStock=(group)=>{
    const next=group.nextElementSibling;
    if(next&&next.matches&&next.matches('[data-set-option-stock]'))return next;
    return group.querySelector('[data-set-option-stock]');
  };
  const syncOptionStocks=(root)=>{
    root.querySelectorAll('[data-size-option]').forEach((group)=>{
      const stock=findOptionStock(group);
      if(!stock)return;
      const checked=group.querySelector('input:checked');
      const textEl=stock.querySelector('[data-stock-text]');
      if(!checked){stock.hidden=true;return;}
      const tone=mapTone(checked.value);
      stock.hidden=false;
      stock.dataset.tone=tone;
      if(textEl){
        textEl.textContent=tone==='orange'?(stock.dataset.few||'')
          :tone==='red'?(stock.dataset.almost||'')
          :(stock.dataset.available||'');
      }
    });
  };
  const patchRoot=(root)=>{
    if(!root||root.__setStockPatched)return;
    if(!root.querySelector('[data-set-option-stock]'))return;
    root.__setStockPatched=true;
    if(typeof root.update==='function'){
      const orig=root.update.bind(root);
      root.update=function(){orig();syncOptionStocks(root);};
    }
    root.addEventListener('change',()=>requestAnimationFrame(()=>syncOptionStocks(root)));
    syncOptionStocks(root);
  };
  const boot=()=>{
    document.querySelectorAll('malim-product').forEach(patchRoot);
  };
  if(customElements.get('malim-product'))boot();
  else customElements.whenDefined('malim-product').then(()=>requestAnimationFrame(boot));
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',boot,{once:true});
  else requestAnimationFrame(boot);
})();
(function(){const PARAMS=['hoodie','jogger'];const PREVIEW_KEY='malim_preview_theme_id';const rememberPreview=()=>{try{const cur=new URL(location.href);const fromUrl=cur.searchParams.get('preview_theme_id');if(fromUrl){sessionStorage.setItem(PREVIEW_KEY,fromUrl);return fromUrl;}return sessionStorage.getItem(PREVIEW_KEY)||null;}catch(_e){return null;}};rememberPreview();const readSizes=(root)=>{const out={};root.querySelectorAll('[data-size-option]').forEach((group)=>{const name=(group.getAttribute('data-option-name')||'').toLowerCase();const checked=group.querySelector('input:checked');if(!checked)return;if(name.indexOf('hoodie')!==-1)out.hoodie=checked.value;else if(name.indexOf('jogger')!==-1)out.jogger=checked.value;});return out;};const applySizes=(root)=>{const url=new URL(location.href);let changed=false;PARAMS.forEach((key)=>{const val=url.searchParams.get(key);if(!val)return;root.querySelectorAll('[data-size-option]').forEach((group)=>{const name=(group.getAttribute('data-option-name')||'').toLowerCase();const match=(key==='hoodie'&&name.indexOf('hoodie')!==-1)||(key==='jogger'&&name.indexOf('jogger')!==-1);if(!match)return;const input=[...group.querySelectorAll('input[type="radio"]')].find((el)=>String(el.value).toUpperCase()===String(val).toUpperCase()&&!el.disabled);if(input&&!input.checked){input.checked=true;changed=true;}});});if(changed){if(typeof root.update==='function')root.update();else root.dispatchEvent(new Event('change',{bubbles:true}));}};const wireLinks=(root)=>{if(!root||root.__colorSwatchWired)return;const block=root.querySelector('[data-color-swatch]');if(!block)return;root.__colorSwatchWired=true;block.querySelectorAll('[data-color-link]').forEach((a)=>{a.addEventListener('click',(ev)=>{if(a.getAttribute('aria-current')==='true'){ev.preventDefault();return;}try{const dest=new URL(a.getAttribute('href'),location.origin);const cur=new URL(location.href);const preview=cur.searchParams.get('preview_theme_id')||rememberPreview();if(preview)dest.searchParams.set('preview_theme_id',preview);const sizes=readSizes(root);PARAMS.forEach((k)=>{if(sizes[k])dest.searchParams.set(k,sizes[k]);});ev.preventDefault();location.href=dest.pathname+dest.search+dest.hash;}catch(_e){}});});applySizes(root);};const boot=()=>{document.querySelectorAll('malim-product').forEach(wireLinks);};if(customElements.get('malim-product'))boot();else customElements.whenDefined('malim-product').then(()=>requestAnimationFrame(boot));if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',boot,{once:true});else requestAnimationFrame(boot);})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["malim-product"]) return;
  try {
    
if(!customElements.get('malim-product-heading')){
  customElements.define('malim-product-heading',class extends HTMLElement{
    connectedCallback(){
      this.titleElement=this.querySelector('h1');
      this.titleBox=this.querySelector('.m-product__title');
      this.priceBox=this.querySelector('.m-product__price-group');
      if(!this.titleElement||!this.titleBox||!this.priceBox)return;
      this.context=document.createElement('canvas').getContext('2d');
      this.resize=new ResizeObserver(()=>this.schedule());
      this.resize.observe(this.titleBox);
      this.mutations=new MutationObserver(()=>this.schedule());
      this.mutations.observe(this.priceBox,{childList:true,subtree:true,characterData:true,attributes:true,attributeFilter:['hidden']});
      document.fonts.ready.then(()=>{if(this.isConnected)this.schedule();});
      this.schedule();
    }
    schedule(){
      if(this.frame)cancelAnimationFrame(this.frame);
      this.frame=requestAnimationFrame(()=>this.fit());
    }
    fit(){
      this.frame=0;
      if(!this.isConnected||!this.context)return;
      const available=this.titleBox.clientWidth;
      if(!available)return;
      const style=getComputedStyle(this.titleElement);
      const base=parseFloat(getComputedStyle(this).getPropertyValue('--m-title-base'))||22;
      const text=this.titleElement.textContent.trim();
      this.context.font=`${style.fontStyle} ${style.fontWeight} ${base}px ${style.fontFamily}`;
      const current=parseFloat(style.fontSize)||base;
      const spacing=(parseFloat(style.letterSpacing)||0)*base/current;
      const measured=this.context.measureText(text).width+spacing*Math.max(0,text.length-1);
      const minimum=Math.min(base,16);
      const fitted=measured<=available?base:Math.max(minimum,Math.floor(base*(available-1)/measured*10)/10);
      const value=`${fitted}px`;
      if(this.titleElement.style.getPropertyValue('--m-fit-title-size')!==value)this.titleElement.style.setProperty('--m-fit-title-size',value);
    }
    disconnectedCallback(){
      this.resize?.disconnect();
      this.mutations?.disconnect();
      if(this.frame)cancelAnimationFrame(this.frame);
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["malim-ugc"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('malim-ugc')){
  customElements.define('malim-ugc',class extends HTMLElement{
    connectedCallback(){
      if(this.controller)return;
      this.track=this.querySelector('[data-ugc-track]');
      if(!this.track)return;
      this.originals=[...this.track.children].filter(item=>!item.hasAttribute('data-ugc-clone'));
      this.controller=new AbortController();
      const signal=this.controller.signal;
      this.mobileQuery=matchMedia('(max-width:749px)');
      this.mobileQuery.addEventListener('change',()=>this.configure(),{signal});
      this.supportsScrollEnd='onscrollend' in window;
      this.track.addEventListener('scroll',()=>this.onScroll(),{passive:true,signal});
      this.track.addEventListener('scrollend',()=>this.recenter(),{signal});
      this.track.addEventListener('touchstart',()=>{this.touching=true;clearTimeout(this.settleTimer);},{passive:true,signal});
      const releaseTouch=event=>{this.touching=event.touches.length>0;if(!this.touching)this.onScroll();};
      this.track.addEventListener('touchend',releaseTouch,{passive:true,signal});
      this.track.addEventListener('touchcancel',releaseTouch,{passive:true,signal});
      this.track.addEventListener('keydown',event=>{
        if(!this.active||event.target!==this.track)return;
        if(event.key==='ArrowLeft'||event.key==='ArrowRight'){event.preventDefault();this.move(event.key==='ArrowLeft'?-1:1);}
      },{signal});
      this.addEventListener('shopify:block:select',event=>{
        const item=event.target.closest?.('.m-ugc__item');
        if(this.active&&item&&this.track.contains(item))this.track.scrollTo({left:this.itemPosition(item),behavior:'auto'});
      },{signal});
      this.lastWidth=0;
      this.observer=new ResizeObserver(()=>{const w=this.track.clientWidth;if(Math.abs(w-this.lastWidth)>1){this.lastWidth=w;this.measure(true);}});
      this.observer.observe(this.track);
      this.configure();
    }
    itemPosition(item){
      return item.getBoundingClientRect().left-this.track.getBoundingClientRect().left+this.track.scrollLeft-this.track.clientLeft;
    }
    configure(){
      clearTimeout(this.settleTimer);
      this.loopWidth=0;this.origin=0;this.touching=false;
      this.active=this.mobileQuery.matches&&this.originals.length>1&&!!this.track.querySelector('[data-ugc-clone="after"]');
      if(!this.active){this.track.removeAttribute('tabindex');this.track.scrollLeft=0;return;}
      this.track.setAttribute('tabindex','0');
      this.measure(true);
    }
    measure(reset){
      if(!this.active)return;
      const fraction=this.loopWidth?(((this.track.scrollLeft-this.origin)%this.loopWidth)+this.loopWidth)%this.loopWidth:0;
      const origin=this.itemPosition(this.originals[0]);
      const firstAfter=this.track.querySelector('[data-ugc-clone="after"]');
      const period=this.itemPosition(firstAfter)-origin;
      if(period<=0)return;
      const ratio=this.loopWidth?fraction/this.loopWidth:0;
      this.origin=origin;this.loopWidth=period;
      if(reset)this.setLeft(origin+ratio*period);
    }
    setLeft(left){
      /* Sprung um exakt ganze Sets: Snap-Position bleibt identisch, daher unsichtbar */
      const prev=this.track.style.scrollBehavior;
      this.track.style.scrollBehavior='auto';
      this.track.scrollLeft=left;
      this.track.style.scrollBehavior=prev;
    }
    onScroll(){
      if(!this.active)return;
      clearTimeout(this.settleTimer);
      /* Fallback ohne scrollend (ältere iOS): erst nach echter Ruhe */
      this.settleTimer=setTimeout(()=>this.recenter(),this.supportsScrollEnd?600:260);
    }
    recenter(){
      if(!this.active||!this.loopWidth||this.touching)return;
      clearTimeout(this.settleTimer);
      const left=this.track.scrollLeft;
      const sets=Math.round((left-this.origin)/this.loopWidth);
      if(sets===0)return;
      const last=left;
      requestAnimationFrame(()=>{
        if(this.touching||Math.abs(this.track.scrollLeft-last)>.5)return; /* bewegt sich noch */
        this.setLeft(this.track.scrollLeft-sets*this.loopWidth);
      });
    }
    move(direction){
      const current=this.track.scrollLeft;
      const positions=[...this.track.children].map(item=>this.itemPosition(item));
      const target=direction>0?positions.find(p=>p>current+2):positions.reverse().find(p=>p<current-2);
      if(target!==undefined)this.track.scrollTo({left:target,behavior:matchMedia('(prefers-reduced-motion:reduce)').matches?'auto':'smooth'});
    }
    disconnectedCallback(){
      this.controller?.abort();this.observer?.disconnect();clearTimeout(this.settleTimer);this.controller=null;
    }
  });
}

  } catch(e) { console.error(e); }
})();
})();
